import { ModuleExtensions } from '@wix/premium-fed-sdk/@premium-module';
import { resourceLoader, CORE_DOMAIN_SEARCH_TRANSLATIONS_NS } from '../../assets/resourceLoader';
export const CoreDomainSearchTranslationsExtension = ModuleExtensions.translationsExtension(resourceLoader, {
  namespace: CORE_DOMAIN_SEARCH_TRANSLATIONS_NS
});
//# sourceMappingURL=CoreDomainSearchTranslationsExtension.js.map